module.exports = __webpack_public_path__ + "static/media/fullsize.c7bf2d8f.png";